"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AnimatedView", {
  enumerable: true,
  get: function get() {
    return _index.default;
  }
});
exports.default = exports.Tabs = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = _interopRequireDefault(require("./animated-view/index.js"));

var _regular = _interopRequireDefault(require("./variants/regular.js"));

var _fullwidth = _interopRequireDefault(require("./variants/fullwidth.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// Padding container
var PaddingContainer = _styledComponents.default.div(_templateObject(), function (props) {
  return props.padding || '0';
}, function (props) {
  return props.theme.palette.black.lighter;
}); // Expose the logic for the tabs components


var Tabs = function Tabs(props) {
  var fullWidth = props.fullWidth,
      padding = props.padding,
      className = props.className,
      componentProps = _objectWithoutProperties(props, ["fullWidth", "padding", "className"]);

  var Component = fullWidth ? _fullwidth.default : _regular.default;

  if (process && process.env === 'dev') {
    console.error('The Clean tabs has been deprecated, please swich to ResponsiveTabs');
  }

  return _react.default.createElement(PaddingContainer, {
    padding: padding
  }, _react.default.createElement(Component, _extends({}, componentProps, {
    className: "tabs_children_".concat(props.children.length, " ").concat(className)
  }), props.children));
};

exports.Tabs = Tabs;
Tabs.propTypes = {
  children: _propTypes.default.any,
  padding: _propTypes.default.string,
  fullWidth: _propTypes.default.bool,
  customVariation: _propTypes.default.any,
  className: _propTypes.default.string
};
var _default = Tabs;
exports.default = _default;